module.exports = __webpack_public_path__ + "static/knshtyk-8558f9549800ed1f6c1a40b648bad674.jpg";